import SvgIcon from '@mui/material/SvgIcon';

/**
 * ThumbnailNavigationRightIcon ~
 */
export default function MiradorIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 55" {...props}>
      <rect width="18" height="55" />
      <rect width="18" height="55" transform="translate(42)" />
      <rect width="18" height="34" transform="translate(21)" />
    </SvgIcon>
  );
}
